import React from "react";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
} from "react-share";

const defaultObj = {};

const FacebookShareWidget = ({
  shareUrl,
  iconFillColor = "",
  title = "",
  className = "",
  round = false,
  bgStyle = defaultObj,
}) => (
  <FacebookShareButton url={shareUrl} quote={title} className={className}>
    <FacebookIcon round={round} iconFillColor={iconFillColor} bgStyle={bgStyle} />
  </FacebookShareButton>
);

const TwitterShareWidget = ({
  shareUrl,
  iconFillColor = "",
  title = "",
  className = "",
  round = false,
  bgStyle = defaultObj,
}) => (
  <TwitterShareButton url={shareUrl} quote={title} className={className}>
    <TwitterIcon round={round} iconFillColor={iconFillColor} bgStyle={bgStyle} />
  </TwitterShareButton>
);

const LinkedinShareWidget = ({
  shareUrl,
  iconFillColor = "",
  title = "",
  className = "",
  round = false,
  bgStyle = defaultObj,
}) => (
  <LinkedinShareButton url={shareUrl} quote={title} className={className}>
    <LinkedinIcon round={round} iconFillColor={iconFillColor} bgStyle={bgStyle} />
  </LinkedinShareButton>
);

const EmailShareWidget = ({
  shareUrl,
  iconFillColor = "",
  subject = "",
  body = "",
  className = "",
  round = false,
  bgStyle = defaultObj,
}) => (
  <EmailShareButton url={shareUrl} subject={subject} body={body} className={className}>
    <EmailIcon round={round} iconFillColor={iconFillColor} bgStyle={bgStyle} />
  </EmailShareButton>
);

export default { FacebookShareWidget, TwitterShareWidget, LinkedinShareWidget, EmailShareWidget };
